import { useText } from '../../../utils/hooks/use_text';
import { useInputComboboxContext } from './_input_combobox.context';

export function InputComboboxTrigger() {
	const { value, options, placeholder } = useInputComboboxContext();
	const staticText = useText();

	if (value.length === 0) {
		return placeholder ?? staticText('Component.InputCombobox.Placeholder');
	}

	if (value.length > 1) {
		return staticText('Component.InputCombobox.MultipleSelectedValue', { count: `${value.length}` });
	}

	return options.find((o) => o.value === value[0])?.label ?? 'NO LABEL';
}
